import { render } from "./CustomerDetailOverviewTab.vue?vue&type=template&id=68368e74"
import script from "./CustomerDetailOverviewTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailOverviewTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__